import { Visit } from "../../CRUDs/entities/Visit";
import { Customer } from "../../CRUDs/entities/Customer";
import { checkActionAttribute } from "./checkActionAttribute";
import { CRUDFabric } from "../../CRUDs/CRUDFabric";
import { error } from "jquery";

export const workersTargetsModalActionsListners = (target, actionsWindow, parents=null) => {
    actionsWindow.find('.action').off();
    const entityType = target.parent().attr('data-type');
    const entityId = target.parent().attr('data-id');

    const entityClass = CRUDFabric.getClass(entityType);
    const entity = new entityClass(entityId);

        checkActionAttribute([
            { attribute: 'data-customer-active',     className: 'contact-customer' },
            { attribute: 'data-customer-active',     className: 'leave-comments' },
            { attribute: 'data-customer-active',     className: 'upload-files' },
        ], target, actionsWindow, parents);

    actionsWindow.find('.action').off();

    // contact customer
    actionsWindow.find('.action.contact-customer').on('click', async (e) => {
        const customerId = target.parent().attr('data-customer-id');
        const isCockpit = target.parent().attr('data-cockpit-permission') != undefined;
        if(isCockpit){
            $.ajax({
                url: `/cockpit/${customerId}`,
                success: () => {
                    const customerLink = `/cockpit/${customerId}`;
                    window.open(customerLink, '_blank');
                },
                error: () => {
                    const customer = new Customer(customerId);
                    customer.openModal('contact');
                }
            });
        }else{
            const customer = new Customer(customerId);
            customer.openModal('contact');
        }
    });

    // leave-comments
    actionsWindow.find('.action.leave-comments').on('click', (e) => {
        $('#leave-comments-modal').modal('show');
        $('#leave-comments-modal button.comment-button').data('job-id', entityId);
        $('#leave-comments-modal button.comment-button').data('type', entityType);
    });

    // upload files
    actionsWindow.find('.action.upload').on('click', (e) => {
        entity.openDropZone();
    });
}
